import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Button, IconButton, Toolbar, makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import ChatDisclaimerInfoIcon from 'components/RightPane/ChatDisclaimerInfoIcon'
import ChatDisclaimerInfoIconBeta from 'components/RightPane/ChatDisclaimerInfoIconBeta'
import { useShowRightMostPane } from 'pages/ProjectsPage/WorkspacePage/components/WorkspaceRightPane/context/RightMostPaneContext'
import useBetaWorkspaceToggle from 'pages/ProjectsPage/WorkspacePage/components/WorkspaceRightPane/hooks/useBetaWorkspaceToggle'
import React from 'react'
import { useChatMessageStore } from './useChatMessageStore'

export interface ChatToolbarStylesProps {
    isBetaWorkspaceToggleEnabled?: boolean
    isOnHeader?: boolean
}

const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(0.5),
    },
    toolbarTitle: {
        fontFamily: 'Roboto',
        fontSize: pxToRem(14),
        fontWeight: 600,
        color: '#185E8E',
        whiteSpace: 'nowrap',
    },
    disclaimerButton: (props: ChatToolbarStylesProps) => ({
        fontFamily: 'Roboto',
        fontSize: pxToRem(12),
        fontWeight: 400,
        ...(props.isBetaWorkspaceToggleEnabled && {
            color: '#185E8E',
            paddingLeft: props.isOnHeader ? pxToRem(240) : pxToRem(180),
        }),
    }),
    closeButton: {
        paddingLeft: 5,
        color: '#185E8E',
        fontSize: pxToRem(14),
    },
}))

export interface ChatToolbarProps {
    isOnHeader?: boolean
}

const ChatToolbar = ({ isOnHeader = false }: ChatToolbarProps) => {
    const isBetaWorkspaceToggleEnabled = useBetaWorkspaceToggle()
    const classes = useStyles({ isBetaWorkspaceToggleEnabled, isOnHeader })
    const setIsDisclaimerOpen = useChatMessageStore(
        (state) => state.setIsDisclaimerOpen
    )

    const setShowRightMostPane = !isOnHeader
        ? useShowRightMostPane().setShowRightMostPane
        : undefined

    const showDisclaimer = () => {
        setIsDisclaimerOpen(true)
    }

    const handleClose = React.useCallback(() => {
        if (setShowRightMostPane) setShowRightMostPane(false)
    }, [isOnHeader])

    return (
        <Toolbar
            variant="dense"
            className={classes.toolbar}
            data-testid="chatToolbar"
            aria-labelledby="toolbarTitle"
        >
            <div
                id="toolbarTitle"
                className={isBetaWorkspaceToggleEnabled && classes.toolbarTitle}
            >
                Ask Dela
            </div>
            <Button
                id="showDisclaimerButton"
                data-testid="showDisclaimerButton"
                type="button"
                aria-label="Show Disclaimer"
                role="button"
                color="inherit"
                className={classes.disclaimerButton}
                startIcon={
                    isBetaWorkspaceToggleEnabled ? (
                        <ChatDisclaimerInfoIconBeta />
                    ) : (
                        <ChatDisclaimerInfoIcon />
                    )
                }
                onClick={showDisclaimer}
            >
                Disclaimer
            </Button>
            {isBetaWorkspaceToggleEnabled && !isOnHeader && (
                <IconButton
                    className={classes.closeButton}
                    data-testid="closePanel"
                    aria-label="Close Panel"
                    onClick={handleClose}
                    disableRipple
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}
        </Toolbar>
    )
}

export default ChatToolbar
